import type { Dispatch } from 'redux';

import { actionUpdateBusinessAddressLine1 } from 'src/app/state/modules/app/businessAddress/addressLine1';
import { actionUpdateBusinessAddressLine2 } from 'src/app/state/modules/app/businessAddress/addressLine2';
import { actionUpdateBusinessCountryId } from 'src/app/state/modules/app/businessAddress/countryId';
import { actionUpdateBusinessPostcode } from 'src/app/state/modules/app/businessAddress/postcode';
import { actionUpdateBusinessState } from 'src/app/state/modules/app/businessAddress/state';
import { actionUpdateBusinessSuburb } from 'src/app/state/modules/app/businessAddress/suburb';

export default (field: string, value: string) => (dispatch: Dispatch) => {
  switch (field) {
    case 'addressLine1':
      return dispatch(actionUpdateBusinessAddressLine1(value));

    case 'addressLine2':
      return dispatch(actionUpdateBusinessAddressLine2(value));

    case 'countryId':
      return dispatch(actionUpdateBusinessCountryId(value));

    case 'state':
      return dispatch(actionUpdateBusinessState(value));

    case 'suburb':
      return dispatch(actionUpdateBusinessSuburb(value));

    case 'postCode':
      return dispatch(actionUpdateBusinessPostcode(value));

    default:
      return null;
  }
};
